import { render, staticRenderFns } from "./ProdOrderSchForm.vue?vue&type=template&id=544a22de&"
import script from "./ProdOrderSchForm.vue?vue&type=script&lang=js&"
export * from "./ProdOrderSchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports